import { createSlice } from "@reduxjs/toolkit";

const initialState = { 
    employeeEligiblity: []
}

const cfcLoanSlice = createSlice({
name: "cfcLoan",
    initialState,
    reducers: {
        setEmployeeEligiblity: (state, action) => {
            state.employeeEligiblity = action.payload
        }
    }
})

export const { setEmployeeEligiblity } = cfcLoanSlice.actions

export default cfcLoanSlice.reducer;